import Image1 from '../assets/solutions/offices.webp'
import Image2 from '../assets/solutions/shared-rooms.webp'
import Image3 from '../assets/solutions/meet-rooms.webp'
import Image4 from '../assets/solutions/events.webp'
import { Link } from 'react-router-dom'
import ArrowRightIcon from '../assets/icons/ArrowRightIcon'


const CARDS = [
  {
    title: 'Oficinas',
    description: 'Enfocate en tu proyecto, optimizá el tiempo y motivá a tu equipo en un entorno flexible, profesional y totalmente equipado.',
    link: '/oficinas',
    image: Image1
  }, {
    title: 'Espacio compartido',
    description: 'Un espacio cálido para crecer. Ideal para profesionales y equipos que buscan flexibilidad, conexión y acceso a espacios dinámicos.',
    link: '/planes',
    image: Image2
  }, {
    title: 'Salas de reuniones',
    description: 'Salas equipadas para potenciar ideas. Espacios cómodos y diseñados para reuniones productivas.',
    link: '/salas-de-reuniones',
    image: Image3
  }, {
    title: 'Eventos',
    description: 'Tu evento personalizado con planificación integral, catering de excelencia, tecnología de última generación y un equipo comprometido, todo en un entorno natural incomparable.',
    link: '/eventos',
    image: Image4
  }
]

const SolutionCards = () => {
  return (
    <div className="SolutionCards container-custom">
      {CARDS.map((card, index) => (
        <div
          key={`Solution-Card-${index}`}
          className="SolutionCards__Card"
        >
          <img
            className='SolutionCards__Card-Image'
            src={card.image}
            alt={card.title}
            title={card.title}
          />

          <div className="SolutionCards__Card-Content">
            <div className="SolutionCards__Card-Text">
              <h3 className="caption">
                { card.title }
              </h3>
              <p className="text-4 text-gray-dark">
                { card.description }
              </p>
            </div>

            <Link
              className='button-new-orange d-flex gap-2'
              to={card.link}
            >
              Ver más
              <ArrowRightIcon width={20} height={20}/>
            </Link>
          </div>
        </div>
      ))}
    </div>
  )
}

export default SolutionCards